/* Kopstorm 24 Sep 2026: themeCurrency lives inside theme.js and is not global, so this file threw
   "themeCurrency is not defined" on every page. This helper uses it when available and otherwise formats
   the amount itself. */
function kopFormatMoney(cents, format) {
  if (typeof themeCurrency !== 'undefined' && themeCurrency.formatMoney) return themeCurrency.formatMoney(cents, format);
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, format);
  var value = (Number(cents) || 0) / 100;
  var fmt = format || '{{amount}}';
  var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
  var type = match ? match[1] : 'amount';
  function split(v, decimals, thousands, decimal) {
    var parts = v.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimals ? decimal : '');
  }
  var out;
  switch (type) {
    case 'amount_no_decimals': out = split(value, 0, ',', '.'); break;
    case 'amount_with_comma_separator': out = split(value, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': out = split(value, 0, '.', ','); break;
    case 'amount_with_apostrophe_separator': out = split(value, 2, "'", '.'); break;
    case 'amount_with_space_separator': out = split(value, 2, ' ', ','); break;
    default: out = split(value, 2, ',', '.');
  }
  return match ? fmt.replace(match[0], out) : out;
}

/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // ============================================
  // Market-specific free shipping thresholds
  // Uses settings from theme.settings.free_shipping (defined in theme.liquid)
  // ============================================
  
  // European countries that default to EUR threshold
  const europeanCountries = ['AD','AL','AT','BY','BE','BA','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IS','IE','IT','LV','LI','LT','LU','MT','MD','MC','ME','NL','NO','PL','PT','RO','RU','SM','RS','SK','SI','ES','SE','CH','UA','GB','VA','XK'];

  // Store current cart for reference
  let currentCart = null;
  let isUpdating = false; // Prevent infinite loops from MutationObserver

  function getMarketFreeShippingThreshold() {
    const freeShippingSettings = window.theme && window.theme.settings && window.theme.settings.free_shipping;
    
    if (!freeShippingSettings) {
      return 80; // Fallback if settings not available
    }
    
    // Try to get currency from multiple sources
    let currency = null;
    
    // First, try window.Shopify.currency.active (might be in different format)
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      currency = window.Shopify.currency.active;
      // Normalize currency code - remove any extra characters and handle different formats
      currency = currency.toUpperCase().trim();
      // Handle cases where it might be "EUR" or "€" or "EURO"
      if (currency === '€' || currency === 'EURO') {
        currency = 'EUR';
      }
    }
    
    // Also check for currency in cart data if available
    if (!currency && currentCart && currentCart.currency) {
      currency = currentCart.currency.toUpperCase().trim();
      if (currency === '€' || currency === 'EURO') {
        currency = 'EUR';
      }
    }
    
    // Check for currency-specific setting first
    if (currency && freeShippingSettings[currency]) {
      const threshold = parseInt(freeShippingSettings[currency], 10);
      if (!isNaN(threshold) && threshold > 0) {
        return threshold;
      }
    }
    
    // Check if European country - use EUR setting as fallback
    const countryCode = window.Shopify && window.Shopify.country ? window.Shopify.country : null;
    if (countryCode && europeanCountries.includes(countryCode)) {
      // Try EUR setting
      if (freeShippingSettings.EUR) {
        const threshold = parseInt(freeShippingSettings.EUR, 10);
        if (!isNaN(threshold) && threshold > 0) {
          return threshold;
        }
      }
    }
    
    // Also check if we're using EUR based on money format or other indicators
    if (window.theme && window.theme.moneyFormat) {
      const moneyFormat = window.theme.moneyFormat;
      if (moneyFormat.indexOf('€') !== -1 || moneyFormat.indexOf('EUR') !== -1) {
        if (freeShippingSettings.EUR) {
          const threshold = parseInt(freeShippingSettings.EUR, 10);
          if (!isNaN(threshold) && threshold > 0) {
            return threshold;
          }
        }
      }
    }
    
    // Return default
    const defaultThreshold = parseInt(freeShippingSettings.default, 10);
    return (!isNaN(defaultThreshold) && defaultThreshold > 0) ? defaultThreshold : 80;
  }

  function updateCartShippingMessage(cart) {
    if (!cart) cart = currentCart;
    if (!cart) return;
    if (isUpdating) return; // Prevent infinite loops
    
    isUpdating = true;
    currentCart = cart;
    
    const cartTotal = cart.total_price;
    
    // NOTE: [data-left-to-spend] elements are handled entirely by Liquid template
    // No JavaScript updates for these elements - Liquid calculates: free_shipping_eur - cart.total_price

    // Update progress wheel
    document.querySelectorAll('[data-cart-progress]').forEach(function(el) {
      // Get threshold from parent cart message element if available
      const cartMessage = el.closest('[data-cart-message]');
      let threshold = null;
      
      if (cartMessage && cartMessage.hasAttribute('data-limit')) {
        threshold = parseFloat(cartMessage.getAttribute('data-limit'));
      }
      
      // Fallback to JavaScript calculation if data-limit not available
      if (!threshold || isNaN(threshold)) {
        threshold = getMarketFreeShippingThreshold();
      }
      
      const thresholdInCents = threshold * 100;
      const percent = Math.min((cartTotal / thresholdInCents) * 100, 100);
      const circumference = 28 * Math.PI;
      const offset = circumference - (percent / 100 * circumference / 2);
      el.style.strokeDashoffset = offset;
    });

    // Update success state
    document.querySelectorAll('[data-cart-message]').forEach(function(el) {
      // Get threshold from data-limit attribute if available
      let threshold = null;
      if (el.hasAttribute('data-limit')) {
        threshold = parseFloat(el.getAttribute('data-limit'));
      }
      
      // Fallback to JavaScript calculation if data-limit not available
      if (!threshold || isNaN(threshold)) {
        threshold = getMarketFreeShippingThreshold();
      }
      
      const thresholdInCents = threshold * 100;
      const hasQualifiedMessage = el.getAttribute('data-cart-message') === 'true';
      if (cartTotal >= thresholdInCents && cartTotal !== 0 && hasQualifiedMessage) {
        el.classList.add('is-success');
      } else {
        el.classList.remove('is-success');
      }
    });
    
    // Reset flag after a short delay
    setTimeout(function() { isUpdating = false; }, 10);
  }

  // Function to restore correct Liquid-calculated value for [data-left-to-spend] elements
  // This fixes theme.js incorrectly updating these elements
  function restoreLiquidLeftToSpend() {
    if (!currentCart) return;
    
    const cartTotal = currentCart.total_price;
    
    document.querySelectorAll('[data-left-to-spend]').forEach(function(el) {
      // Get the threshold from the parent cart message element's data-limit attribute
      // This is set by the Liquid template and is the correct threshold
      const cartMessage = el.closest('[data-cart-message]');
      
      if (cartMessage && cartMessage.hasAttribute('data-limit')) {
        const threshold = parseFloat(cartMessage.getAttribute('data-limit'));
        
        if (!isNaN(threshold) && threshold > 0) {
          // Calculate the correct remaining amount using Liquid's threshold
          const thresholdInCents = threshold * 100;
          const remaining = thresholdInCents - cartTotal;
          
          if (remaining >= 0) {
            // Format the amount using the same method as Liquid template
            // Liquid uses: money_with_currency if currency_code_enable, else money_without_trailing_zeros
            const currencyCodeEnabled = window.theme && window.theme.settings && window.theme.settings.currency_code_enable;
            let formattedAmount = kopFormatMoney(remaining, theme.moneyFormat);
            
            // Remove trailing .00 to match Liquid's money_without_trailing_zeros
            formattedAmount = formattedAmount.replace('.00', '');
            
            // If currency code is enabled, add it (matching Liquid's money_with_currency)
            if (currencyCodeEnabled) {
              const currencyCode = currentCart.currency || window.theme.currencyCode || 'EUR';
              formattedAmount = formattedAmount + ' ' + currencyCode;
            }
            
            // Restore the correct Liquid-calculated value
            el.innerHTML = formattedAmount;
          }
        }
      }
    });
  }

  // MutationObserver to watch for theme.js incorrectly updating [data-left-to-spend] elements
  // and restore the correct Liquid-calculated value
  function setupLiquidValueProtection() {
    const observer = new MutationObserver(function(mutations) {
      // Skip if we're the ones making changes
      if (isUpdating) return;
      
      let needsRestore = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const target = mutation.target;
          // Check if this is a [data-left-to-spend] element or its parent
          const leftToSpendEl = target.closest ? target.closest('[data-left-to-spend]') : null;
          if (leftToSpendEl || (target.hasAttribute && target.hasAttribute('data-left-to-spend'))) {
            const cartMessage = (leftToSpendEl || target).closest('[data-cart-message]');
            // Only restore if it has data-limit (set by Liquid template)
            if (cartMessage && cartMessage.hasAttribute('data-limit')) {
              needsRestore = true;
            }
          }
        }
      });
      
      // Restore correct Liquid value after theme.js updates it
      if (needsRestore && currentCart) {
        setTimeout(function() {
          restoreLiquidLeftToSpend();
        }, 10);
      }
    });

    // Observe all [data-left-to-spend] elements
    function observeElements() {
      document.querySelectorAll('[data-left-to-spend]').forEach(function(el) {
        const cartMessage = el.closest('[data-cart-message]');
        // Only observe elements that have data-limit (Liquid rendered them)
        if (cartMessage && cartMessage.hasAttribute('data-limit')) {
          if (!el.hasAttribute('data-liquid-protected')) {
            el.setAttribute('data-liquid-protected', 'true');
            observer.observe(el, { 
              childList: true, 
              characterData: true, 
              subtree: true 
            });
          }
        }
      });
    }

    // Initial observation
    observeElements();

    // Re-observe when drawer opens or cart reloads
    document.addEventListener('theme:drawer:open', function() {
      setTimeout(observeElements, 200);
      setTimeout(restoreLiquidLeftToSpend, 300);
    });
    
    document.addEventListener('theme:cart:reload', function() {
      setTimeout(observeElements, 200);
      setTimeout(restoreLiquidLeftToSpend, 300);
    });
  }

  // Listen for cart changes
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      currentCart = cart;
      // Update progress wheel and success state
      setTimeout(function() { updateCartShippingMessage(cart); }, 100);
      // Restore correct Liquid value after theme.js potentially updates it incorrectly
      setTimeout(function() { restoreLiquidLeftToSpend(); }, 150);
      setTimeout(function() { restoreLiquidLeftToSpend(); }, 300);
    }
  });

  // Listen for cart reload (when drawer content is refreshed)
  document.addEventListener('theme:cart:reload', function(event) {
    // Fetch cart and restore correct Liquid values
    if (currentCart) {
      setTimeout(function() { restoreLiquidLeftToSpend(); }, 200);
      setTimeout(function() { restoreLiquidLeftToSpend(); }, 400);
    } else {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          currentCart = cart;
          setTimeout(function() { restoreLiquidLeftToSpend(); }, 200);
          setTimeout(function() { restoreLiquidLeftToSpend(); }, 400);
        });
    }
  });

  // Also update on cart init
  document.addEventListener('theme:cart:init', function(e) {
    if (e.detail && e.detail.cart) {
      currentCart = e.detail.cart;
      // Update progress wheel and success state
      setTimeout(function() { updateCartShippingMessage(e.detail.cart); }, 100);
      // Restore correct Liquid value
      setTimeout(function() { restoreLiquidLeftToSpend(); }, 150);
    }
  });

  // Update on page load
  document.addEventListener('DOMContentLoaded', function() {
    // Setup protection for Liquid values
    setupLiquidValueProtection();
    
    // Fetch current cart state for progress wheel/success state updates
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        currentCart = cart;
        // Update progress wheel and success state
        updateCartShippingMessage(cart);
        // Restore correct Liquid values
        setTimeout(function() { restoreLiquidLeftToSpend(); }, 200);
        setTimeout(function() { restoreLiquidLeftToSpend(); }, 500);
      })
      .catch(function(err) { console.log('Cart fetch error:', err); });
  });

  // Also watch for drawer opening
  document.addEventListener('click', function(e) {
    // If clicking on cart icon or similar, update after drawer opens
    if (e.target.closest('[data-cart-toggle], [href="/cart"], .cart-link, [data-cart-open]')) {
      setTimeout(function() {
        if (currentCart) {
          // Only update progress wheel and success state, not [data-left-to-spend]
          updateCartShippingMessage(currentCart);
        } else {
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              currentCart = cart;
              // Only update progress wheel and success state, not [data-left-to-spend]
              updateCartShippingMessage(cart);
            });
        }
      }, 300);
    }
  });

})();

// ============================================
// Country selector enhancements + geo-first default
// - Adds search filtering for country lists
// - Persists a "manual selection" flag
// - On first visit (no manual choice), uses Shopify's browsing context suggestion
//   to set the country/market via the localization form
// ============================================

(function () {
  const MANUAL_KEY = 'dar_country_manual';
  const AUTO_KEY = 'dar_country_auto_applied';
  const TOP_COUNTRIES = ['US', 'GB', 'AU', 'NL', 'DE'];

  function safeGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }

  function markManualSelection() {
    safeSet(MANUAL_KEY, '1');
  }

  function getCurrentCountryFromDom() {
    const input =
      document.querySelector('form[action*="/localization"] input[name="country_code"]') ||
      document.querySelector('form input[name="country_code"]');
    if (!input || !input.value) return null;
    return String(input.value).toUpperCase();
  }

  function getAvailableCountryCodesFromDom() {
    const codes = new Set();
    document.querySelectorAll('[data-country-option][data-value], [data-popout-option][data-value]').forEach((el) => {
      const v = el.getAttribute('data-value');
      if (v && v.length === 2) codes.add(v.toUpperCase());
    });
    return codes;
  }

  function submitLocalizationCountry(countryCode) {
    const form =
      document.querySelector('form[action*="/localization"]') ||
      document.querySelector('form#localization-form-footer') ||
      document.querySelector('form[id^="localization-form-"]') ||
      document.querySelector('form');

    const input =
      form && form.querySelector('input[name="country_code"]');

    if (!form || !input) return false;
    input.value = countryCode;
    form.submit();
    return true;
  }

  function parseSuggestedCountryCode(payload) {
    // Shopify has used a few shapes over time; be permissive.
    const candidates = [
      payload?.detected_values?.country?.handle,
      payload?.detected_values?.country?.iso_code,
      payload?.detected_values?.country_code,
      payload?.suggestions?.[0]?.country?.handle,
      payload?.suggestions?.[0]?.country_code,
      payload?.country?.handle,
      payload?.country_code,
    ].filter(Boolean);

    for (const c of candidates) {
      const code = String(c).toUpperCase();
      if (code.length === 2) return code;
    }
    return null;
  }

  async function applyGeoSuggestedCountryOnce() {
    if (safeGet(MANUAL_KEY) === '1') return;
    if (safeGet(AUTO_KEY) === '1') return;

    const current = getCurrentCountryFromDom();
    const available = getAvailableCountryCodesFromDom();
    if (!current || available.size === 0) return;

    // Avoid auto-switching if already on one of the key markets unless the suggestion disagrees.
    // This reduces surprise if Shopify is already doing the right thing.
    let payload;
    try {
      const res = await fetch('/browsing_context_suggestions.json', {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
      });
      if (!res.ok) return;
      payload = await res.json();
    } catch (e) {
      return;
    }

    const suggested = parseSuggestedCountryCode(payload);
    if (!suggested || suggested === current) {
      safeSet(AUTO_KEY, '1');
      return;
    }
    if (!available.has(suggested)) {
      safeSet(AUTO_KEY, '1');
      return;
    }

    // If the current country is NL (common primary market default) and suggestion differs,
    // switch; otherwise only switch when current isn't a top market (minimize unwanted flips).
    const shouldSwitch =
      current === 'NL' ||
      (!TOP_COUNTRIES.includes(current) && TOP_COUNTRIES.includes(suggested)) ||
      true; // Always prefer suggestion over default for first-time visitors

    if (!shouldSwitch) {
      safeSet(AUTO_KEY, '1');
      return;
    }

    const submitted = submitLocalizationCountry(suggested);
    safeSet(AUTO_KEY, '1');
    return submitted;
  }

  function wireSearchFiltering() {
    document.querySelectorAll('[data-country-search]').forEach((input) => {
      if (input.getAttribute('data-wired') === 'true') return;
      input.setAttribute('data-wired', 'true');

      input.addEventListener('input', () => {
        const q = (input.value || '').trim().toLowerCase();
        const wrapper =
          input.closest('[data-country-selector]') ||
          input.closest('.popout') ||
          document;

        const items = wrapper.querySelectorAll('[data-country-item], [data-country-option]');
        const divider = wrapper.querySelector('[data-country-divider]');

        items.forEach((el) => {
          const name = (el.getAttribute('data-country-name') || el.textContent || '').toLowerCase();
          const iso = (el.getAttribute('data-country-iso') || el.getAttribute('data-value') || '').toLowerCase();
          const match = !q || name.includes(q) || iso.includes(q);
          el.style.display = match ? '' : 'none';
        });

        if (divider) divider.style.display = q ? 'none' : '';
      });
    });
  }

  function wireManualSelectionFlag() {
    // Topbar custom selector
    document.addEventListener('click', (e) => {
      const countryOption = e.target && e.target.closest && e.target.closest('[data-country-option]');
      if (countryOption) markManualSelection();

      const popoutOption = e.target && e.target.closest && e.target.closest('[data-popout-option][data-value]');
      if (popoutOption) {
        const value = popoutOption.getAttribute('data-value');
        if (value && value.length === 2) markManualSelection();
      }
    }, { capture: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    wireSearchFiltering();
    wireManualSelectionFlag();
    // Temporarily disabled: geo-based auto country switching/redirect.
    // applyGeoSuggestedCountryOnce();
  });

  // When sections re-render (Shopify theme editor), re-wire search.
  document.addEventListener('shopify:section:load', () => {
    wireSearchFiltering();
  });
})();

// ============================================
// Kopstorm: product form submit safety net (10 Sep 2026)
// If any third party script (e.g. Sizebay size finder) detaches the theme's
// submit handler from the product form, a native POST /cart/add would redirect
// the shopper to /cart. This catches an unhandled submit and adds via Ajax
// so the slide cart / popdown is always used.
// ============================================
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.hasAttribute('data-product-form')) return;
    if (e.defaultPrevented) return; // theme handled it
    if (form.closest('[data-ajax-disable="true"]')) return;

    e.preventDefault();
    var routes = (window.theme && window.theme.routes) || {};
    var cartRoute = routes.cart || '/cart';
    var button = form.querySelector('[data-add-to-cart]');
    if (button) button.classList.add('loading');

    fetch(cartRoute + '/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (button) button.classList.remove('loading');
        if (!result.ok) {
          var errorEl = form.querySelector('[data-error-display]');
          if (errorEl) errorEl.innerHTML = '<div class="errors">' + (result.data.description || result.data.message || 'Error') + '</div>';
          return;
        }
        return fetch(cartRoute + '.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
          if (window.theme && window.theme.state && window.theme.state.cartOpen) {
            document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
          } else {
            var popdown = document.querySelector('[data-product-add-popdown-wrapper]');
            if (popdown) {
              popdown.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: { variant: result.data }, bubbles: true }));
            } else {
              var drawer = document.querySelector('[data-drawer="drawer-cart"]');
              if (drawer) drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
            }
          }
        });
      })
      .catch(function (err) {
        if (button) button.classList.remove('loading');
        console.warn('[Kopstorm] product form fallback failed', err);
      });
  });
})();

/*
 * Collection-card hover image fix (2026-10-05).
 * The theme's ProductGridItemVariant.preloadImages() loops over every child of the card's
 * image holder, but the FC card-slider JSON (<script data-fc-card-media>) also lives there.
 * preloadImage() then throws "No child element at index N" and mouseenter never reaches
 * changeImage(), so hover_state products never show their second image. Loop over images only.
 */
(function () {
  if (!window.customElements) return;
  customElements.whenDefined('product-grid-item-variant').then(function () {
    var GridItem = customElements.get('product-grid-item-variant');
    if (!GridItem || GridItem.prototype.__fcPreloadFix) return;
    GridItem.prototype.__fcPreloadFix = true;
    GridItem.prototype.preloadImages = function () {
      var self = this;
      if (!this.images) return;
      Array.prototype.forEach.call(this.images, function (_el, i) { self.preloadImage(i); });
    };

    /*
     * Smooth second-image swap (2026-10-09).
     * Hidden card images sit in a <template> and on mobile were only requested when the
     * touch-scroll "hover" started, so the card showed its grey #f7f7f7 placeholder until the
     * photo arrived, then flashed. Now:
     *  1. the second image is stamped at low priority shortly before a card scrolls into view;
     *  2. changeImage() waits until the target image is decoded before switching, and a newer
     *     call (e.g. the reset on touchend) cancels a pending switch, so there is no late flash.
     */
    var origChange = GridItem.prototype.changeImage;
    GridItem.prototype.changeImage = function (index) {
      var self = this;
      var token = (this.__fcSwapToken = (this.__fcSwapToken || 0) + 1);
      var target = this.images && this.images[index % this.imageCount];
      if (!target) return origChange.call(this, index);
      stamp(target, 'high');
      var img = target.querySelector('img');
      if (!img || (img.complete && img.naturalWidth)) return origChange.call(this, index);
      var ready = img.decode
        ? img.decode()
        : new Promise(function (res, rej) { img.addEventListener('load', res, { once: true }); img.addEventListener('error', rej, { once: true }); });
      ready.then(go, go);
      function go() { if (token === self.__fcSwapToken) origChange.call(self, index); }
    };

    // Replace a hidden image's <template> with its <img>, at the given fetch priority.
    function stamp(wrapper, priority) {
      var tpl = wrapper.firstElementChild;
      if (!tpl || tpl.nodeName !== 'TEMPLATE') return;
      var content = tpl.content;
      content.querySelectorAll('img').forEach(function (img) {
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', priority);
      });
      tpl.replaceWith(content);
    }

    if (!('IntersectionObserver' in window)) return;
    // Data savers / 2G: skip preloading; the swap still waits for the image, so no grey flash.
    var conn = navigator.connection;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
    var warm = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        warm.unobserve(entry.target);
        var item = entry.target;
        if (item.slideshowStyle === 'disabled' || !item.images || item.imageCount < 2) return;
        var next = item.images[item.getNextIndex()];
        if (next) stamp(next, 'low');
      });
    }, { rootMargin: '300px 0px' });
    function observeAll(root) {
      (root || document).querySelectorAll('product-grid-item-variant').forEach(function (el) {
        if (el.__fcWarm) return;
        el.__fcWarm = true;
        warm.observe(el);
      });
    }
    // Start only after the page has loaded and the browser is idle, so preloading never
    // competes with the first-screen images (LCP) or the load event.
    function start() {
      observeAll();
      // Cards added later (infinite scroll, filters, quick-add) get picked up too. Batched, so
      // the many PDP apps that mutate the DOM don't trigger a scan per mutation.
      var scanQueued = false;
      new MutationObserver(function () {
        if (scanQueued) return;
        scanQueued = true;
        setTimeout(function () { scanQueued = false; observeAll(); }, 250);
      }).observe(document.body, { childList: true, subtree: true });
    }
    function startWhenIdle() {
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2000 });
      else setTimeout(start, 200);
    }
    if (document.readyState === 'complete') startWhenIdle();
    else window.addEventListener('load', startWhenIdle, { once: true });
  });
})();
